import React, { useEffect } from 'react';
import classNames from 'classnames';
import { Button } from '../../Button';
import { Card } from '../../Card';
import { Typography } from '../../Typography';
import "./styles.css";
export var Snackbar = function (_a) {
    var _b = _a.open, open = _b === void 0 ? false : _b, message = _a.message, _c = _a.delay, delay = _c === void 0 ? 3000 : _c, onClose = _a.onClose, action = _a.action, _d = _a.horizontal, horizontal = _d === void 0 ? 'right' : _d, _e = _a.variant, variant = _e === void 0 ? 'elastic' : _e, className = _a.className;
    if (!open)
        return null;
    var actionButton = action && (React.createElement(Button, { variant: 'plain', size: 'medium', className: 'lk-ui_snackbar-body-action', onClick: action === null || action === void 0 ? void 0 : action.onClick }, (action === null || action === void 0 ? void 0 : action.label) || 'Закрыть'));
    useEffect(function () {
        var timer = setTimeout(function () {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }, delay);
        return function () {
            clearTimeout(timer);
        };
    }, []);
    return (React.createElement(Card, { className: classNames('lk-ui_snackbar', open && 'lk-ui_snackbar__open', "lk-ui_snackbar__" + horizontal, 'inverseTheme', className) },
        React.createElement("div", { className: classNames('lk-ui_snackbar-body', "lk-ui_snackbar-body__" + variant) },
            React.createElement(Typography, { variant: 'body3', className: classNames('lk-ui_snackbar-body-message', action && 'lk-ui_snackbar-body-message__with-action', "lk-ui_snackbar-body-message__" + variant) }, message),
            actionButton)));
};
